Ext.define('SA.view.quickreport.drag.QuickReportSwappableColumn', {
    alias: 'quickreport.swappable-column',

    constructor(els) {
        this.headerCell = els.headerCell;
        this.bodyColumn = els.bodyColumn;
    },

    destroy() {
        this.headerCell = null;
        this.bodyColumn = null;
    },

    maybeSwapWithSibling(left, buffer) {
        var headerCell = this.headerCell,
            bodyColumn = this.bodyColumn,
            currentLeft = headerCell.offsetLeft;

        if (shouldMoveLeft()) {
            moveLeft();
        }
        else if (shouldMoveRight()) {
            moveRight();
        }

        function shouldMoveLeft() {
            var previousSibling = headerCell.previousSibling,
                hasPreviousSibling = !!previousSibling;

            return hasPreviousSibling && left < (currentLeft - buffer - (previousSibling.offsetWidth / 2));
        }

        function shouldMoveRight() {
            var nextSibling = headerCell.nextSibling,
                ignoreNextSibling = nextSibling && Ext.fly(nextSibling).hasCls('sa-quick-report-floating-column-header-cell'),
                hasNextSibling = nextSibling && !ignoreNextSibling;

            return hasNextSibling && left > (currentLeft + buffer + (nextSibling.offsetWidth / 2));
        }

        function moveLeft() {
            headerCell.previousSibling.insertAdjacentElement('beforebegin', headerCell);
            bodyColumn.previousSibling.insertAdjacentElement('beforebegin', bodyColumn);
        }

        function moveRight() {
            headerCell.nextSibling.insertAdjacentElement('afterend', headerCell);
            bodyColumn.nextSibling.insertAdjacentElement('afterend', bodyColumn);
        }
    },

    setDragging(bool) {
        Ext.fly(this.headerCell).ifCls(bool, 'sa-quick-report-header-cell-dragging');
        Ext.fly(this.bodyColumn).ifCls(bool, 'sa-quick-report-body-column-dragging');
    }
});